import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { Youtube, Facebook, Instagram, Send, MessageCircle } from "lucide-react";
import { api } from "@/lib/api";

export default function Footer() {
  const [s, setS] = useState({});
  useEffect(() => { api.get("/settings/public").then((r) => setS(r.data || {})).catch(() => {}); }, []);
  return (
    <footer className="mt-20 bg-[#0F172A] text-slate-300" data-testid="site-footer">
      <div className="vr-container py-12 grid gap-10 md:grid-cols-4">
        <div>
          <div className="flex items-center gap-2 mb-3">
            <div className="w-9 h-9 rounded-lg bg-[#DC2626] text-white flex items-center justify-center font-black text-sm">VR</div>
            <div className="font-display font-extrabold text-white text-lg">VR Classes</div>
          </div>
          <p className="text-sm leading-relaxed font-hindi">बिहार बोर्ड कक्षा 9 से 12 तक की सम्पूर्ण तैयारी — निःशुल्क Notes, MCQ Quiz, महत्वपूर्ण प्रश्न एवं YouTube Classes।</p>
          <div className="flex gap-2 mt-4">
            {s.youtube_channel_url && <a href={s.youtube_channel_url} target="_blank" rel="noreferrer" className="w-9 h-9 rounded-full bg-[#DC2626] flex items-center justify-center" data-testid="footer-youtube"><Youtube size={16} /></a>}
            {s.facebook_url && <a href={s.facebook_url} target="_blank" rel="noreferrer" className="w-9 h-9 rounded-full bg-slate-700 flex items-center justify-center"><Facebook size={16} /></a>}
            {s.instagram_url && <a href={s.instagram_url} target="_blank" rel="noreferrer" className="w-9 h-9 rounded-full bg-slate-700 flex items-center justify-center"><Instagram size={16} /></a>}
            {s.telegram_url && <a href={s.telegram_url} target="_blank" rel="noreferrer" className="w-9 h-9 rounded-full bg-slate-700 flex items-center justify-center"><Send size={16} /></a>}
            {s.whatsapp_url && <a href={s.whatsapp_url} target="_blank" rel="noreferrer" className="w-9 h-9 rounded-full bg-slate-700 flex items-center justify-center"><MessageCircle size={16} /></a>}
          </div>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-3">Classes</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/class-9">Class 9</Link></li>
            <li><Link to="/class-10">Class 10 (Matric)</Link></li>
            <li><Link to="/class-11">Class 11</Link></li>
            <li><Link to="/class-12">Class 12 (Inter)</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-3">Study</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/notes">Notes</Link></li>
            <li><Link to="/mcq">MCQ Quiz</Link></li>
            <li><Link to="/important-questions">Important Questions</Link></li>
            <li><Link to="/previous-year-questions">Previous Year Qs</Link></li>
            <li><Link to="/online-tests">Online Tests</Link></li>
            <li><Link to="/youtube">YouTube Classes</Link></li>
            <li><Link to="/english-course">English Course{s.course_price_inr ? ` ₹${s.course_price_inr}` : ""}</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-3">Company</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/contact">Contact</Link></li>
            <li><Link to="/privacy">Privacy Policy</Link></li>
            <li><Link to="/terms">Terms & Conditions</Link></li>
            <li><Link to="/disclaimer">Disclaimer</Link></li>
            <li><Link to="/refund">Refund Policy</Link></li>
            <li><Link to="/copyright">Copyright Policy</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="vr-container py-4 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-slate-400">
          <div>© {new Date().getFullYear()} VR Classes. All rights reserved.</div>
          <div>Made with ❤️ for Bihar Board students · <Link to="/admin/login" className="hover:text-white" data-testid="admin-login-footer">Admin</Link></div>
        </div>
      </div>
    </footer>
  );
}
